import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

import { ImpuestosPredialDesgloseStore } from '../../stores';

import { ImpuestosDesgloseTables } from '../shared';
import { SubformSaveButton } from '../shared/SubformSaveButton';

interface DesgloseFormGroupProps {
    isReadonly: boolean;
    impuestosPredialIngresosStore?: ImpuestosPredialDesgloseStore;
    impuestosPredialDescuentosStore?: ImpuestosPredialDesgloseStore;
}

export const DesgloseSubformWithStore = (
    storeName: 'impuestosPredialIngresosStore' | 'impuestosPredialDescuentosStore'
) => {
    class DesgloseFormGroup extends Component<DesgloseFormGroupProps> {
        render() {
            const { isReadonly, [storeName]: store } = this.props;
            const {
                isSaving,
                isLoading,
                ejercicio,
                desgloseEjercicioRecords,
                desgloseEjercicioAnteriorRecords,
                desgloseTotalRecords,
                setDesgloseEjercicioValue,
                setDesgloseEjercicioAnteriorValue,
                saveDesglose
            } = store!;

            const description =
                storeName === 'impuestosPredialIngresosStore'
                    ? 'IMPUESTO PREDIAL\\nINGRESOS'
                    : 'IMPUESTO PREDIAL\\nDESCUENTOS, SUBSIDIOS, SUBVENCIONES O BONIFICACIONES';

            return (
                <>
                    <ImpuestosDesgloseTables
                        ejercicio={ejercicio}
                        isReadonly={isReadonly}
                        isLoading={isLoading}
                        description={description}
                        desgloseEjercicioRecords={desgloseEjercicioRecords}
                        desgloseEjercicioAnteriorRecords={desgloseEjercicioAnteriorRecords}
                        desgloseTotalRecords={desgloseTotalRecords}
                        onUpdateEjercicioRecord={setDesgloseEjercicioValue}
                        onUpdateEjercicioAnteriorRecord={setDesgloseEjercicioAnteriorValue}
                    />
                    {!isReadonly && <SubformSaveButton isSaving={isSaving} onSave={saveDesglose} />}
                </>
            );
        }
    }

    return inject(storeName)(observer(DesgloseFormGroup));
};
